import { DeliveryType } from "../DeliveryType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const deliveryTypeNameMap: Record<DeliveryType, LocalizedString> = {
	[DeliveryType.DeliveryToAddress]: { [Locale.cs]: "Na adresu", [Locale.en]: "To address" },
	[DeliveryType.DeliveryToParcelShop]: { [Locale.cs]: "Na výdejní místo", [Locale.en]: "To a parcel shop" },
	[DeliveryType.DeliveryToParcelBox]: { [Locale.cs]: "Do boxu", [Locale.en]: "To a parcel box" },
	[DeliveryType.PersonalPickup]: { [Locale.cs]: "Osobní vyzvednutí", [Locale.en]: "Personal pickup" },
};
